import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import toArray from 'lodash/toArray'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit'
import DeleteForever from 'material-ui/svg-icons/action/delete-forever'
import { red500, grey400 } from 'material-ui/styles/colors'

const Main = styled.div`
  padding: 20px 30px;
  position: relative;
  
  .more-actions {
    position: absolute !important;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`

const MoreAction = ({
  menus,
  children,
  color,
  grey,
  anchorOrigin,
  targetOrigin,
}) => (
  <Main>
    {children}
    <IconMenu
      className={'more-actions'}
      iconButtonElement={(
        <IconButton>
          <MoreVertIcon color={grey ? grey400 : color} />
        </IconButton>
      )}
      anchorOrigin={anchorOrigin}
      targetOrigin={targetOrigin}
    >
      {menus && toArray(menus).map((menu) => (
        <MenuItem
          key={menu.name}
          leftIcon={menu.icon}
          primaryText={menu.name}
          onClick={menu.onClick}
        />
      ))}
    </IconMenu>
  </Main>
)

MoreAction.propTypes = {
  children: PropTypes.node,
  menus: PropTypes.object,
  anchorOrigin: PropTypes.object,
  targetOrigin: PropTypes.object,
  color: PropTypes.string,
  grey: PropTypes.bool,
}
MoreAction.defaultProps = {
  children: null,
  menus: {},
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'top',
  },
  targetOrigin: {
    horizontal: 'right',
    vertical: 'top',
  },
  color: '#000000',
  grey: false,
}

MoreAction.Default = ({ onEdit, onDelete, children, menus, ...props }) => (
  <MoreAction
    {...props}
    menus={{
      edit: {
        name: 'Edit',
        icon: (<ModeEdit />),
        onClick: onEdit,
      },
      ...menus,
      delete: {
        name: 'Delete',
        icon: (<DeleteForever color={red500} />),
        onClick: onDelete,
      },
    }}
  >
    {children}
  </MoreAction>
)

MoreAction.Default.propTypes = {
  menus: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  children: PropTypes.node,
}

MoreAction.Default.defaultProps = {
  menus: {},
  onEdit: () => {},
  onDelete: () => {},
  children: null,
}


export default MoreAction



// WEBPACK FOOTER //
// ./src/components/MoreAction/index.js